// SettingsAI.jsx
import React, { useState, useEffect } from "react";
import {
  CModal,
  CModalHeader,
  CModalTitle,
  CModalBody,
  CModalFooter,
  CButton,
  CFormCheck,
  CFormLabel,
  CFormInput,
  CSpinner,
  CAlert,
} from "@coreui/react";
import axios from "axios";

const SettingsAI = ({ visible, onClose }) => {
  const [settings, setSettings] = useState({
    is_in_frames: false,
    frame_sec: 1,
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [localIsInFrames, setLocalIsInFrames] = useState(false);
  const [localFrameSec, setLocalFrameSec] = useState(1);

  const token = localStorage.getItem("token");

  // Загрузка настроек при открытии модального окна
  useEffect(() => {
    if (visible) {
      loadSettings();
    } else {
      // Сброс состояния при закрытии
      setSettings({ is_in_frames: false, frame_sec: 1 });
      setLocalIsInFrames(false);
      setLocalFrameSec(1);
      setError("");
      setSuccess("");
    }
  }, [visible]);

  const loadSettings = async () => {
    setLoading(true);
    setError("");
    try {
      // Предполагаем, что всегда одна запись с id=1
      const response = await axios.get(
        `/api/neural_network_module/settings-ai/?id=1`,
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );

      if (response.data) {
        const data = response.data;
        setSettings({
          is_in_frames: data.is_in_frames ?? false,
          frame_sec: data.frame_sec ?? 1,
        });
        setLocalIsInFrames(data.is_in_frames ?? false);
        setLocalFrameSec(data.frame_sec ?? 1);
      } else {
        setError("Настройки не найдены.");
      }
    } catch (err) {
      console.error("Ошибка при загрузке настроек:", err);
      setError(
        "Не удалось загрузить настройки: " +
          (err.response?.data?.message || err.message),
      );
    } finally {
      setLoading(false);
    }
  };

  const handleSave = async () => {
    setLoading(true);
    setError("");
    setSuccess("");
    try {
      // Обновляем только нужные поля
      const payload = {
        id: 1, // Предполагаем, что ID записи 1
        is_in_frames: localIsInFrames,
        frame_sec: localFrameSec,
      };

      const response = await axios.put(
        `/api/neural_network_module/settings-ai/`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );

      if (response.status === 200) {
        setSettings({
          is_in_frames: localIsInFrames,
          frame_sec: localFrameSec,
        }); // Обновляем исходное состояние
        setSuccess("Настройки успешно сохранены.");
        // Закрываем окно через короткую задержку, чтобы пользователь увидел сообщение
        setTimeout(() => {
          onClose();
        }, 1000);
      } else {
        setError("Не удалось сохранить настройки. Попробуйте снова.");
      }
    } catch (err) {
      console.error("Ошибка при сохранении настроек:", err);
      setError(
        "Ошибка при сохранении: " +
          (err.response?.data?.message || err.message),
      );
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    // Восстанавливаем значения из последнего загруженного состояния
    setLocalIsInFrames(settings.is_in_frames);
    setLocalFrameSec(settings.frame_sec);
    setError("");
    setSuccess("");
    onClose();
  };

  // Стили для ограничения размера модального окна
  const modalStyle = {
    // maxHeight: '30vh',
    maxWight: "40vw",
    display: "flex",
    flexDirection: "column",
  };

  return (
    <CModal
      alignment="start"
      visible={visible}
      onClose={handleCancel}
      backdrop="static"
      style={modalStyle}
    >
      <CModalHeader>
        <CModalTitle>Параметры Neimarker</CModalTitle>
      </CModalHeader>
      <CModalBody>
        {error && <CAlert color="danger">{error}</CAlert>}
        {success && <CAlert color="success">{success}</CAlert>}
        {loading ? (
          <div className="text-center">
            <CSpinner size="sm" />
            <div>Загрузка...</div>
          </div>
        ) : (
          <>
            <div className="mb-3">
              <CFormCheck
                id="isInFramesCheck"
                label="Привязывать дефекты к конструкции"
                checked={localIsInFrames}
                onChange={(e) => setLocalIsInFrames(e.target.checked)}
              />
            </div>
            <div className="mb-3">
              <CFormLabel htmlFor="frameSecInput">
                Брать фрейм каждые (сек.):
              </CFormLabel>
              <CFormInput
                type="number"
                id="frameSecInput"
                value={localFrameSec}
                onChange={(e) => setLocalFrameSec(Number(e.target.value))}
                min="1"
                step="1"
              />
            </div>
          </>
        )}
      </CModalBody>
      <CModalFooter>
        <CButton color="secondary" onClick={handleCancel} disabled={loading}>
          Отмена
        </CButton>
        <CButton color="primary" onClick={handleSave} disabled={loading}>
          ОК
        </CButton>
      </CModalFooter>
    </CModal>
  );
};

export default SettingsAI;
